import React from 'react';
import PropTypes from 'prop-types';
import { getProxyUrl } from '../../../utils/image';
import { getPlayerUrlById } from '../../../utils/routes';

function LeadersHero({ data, type }) {
  const isTeam = type.includes('team');
  const playerUrl = getPlayerUrlById(data?.fogisId);

  const getPlayerName = () => {
    if (!data?.displayName) {
      return { firstRow: data.givenName, secondRow: data.surName };
    }
    const displayName = data?.displayName || '';
    const nameParts = displayName.split(' ');
    const firstRow = nameParts[0];
    const secondRow = nameParts.splice(1, nameParts.length).join(' ');

    return { firstRow, secondRow };
  };

  const getImage = () => {
    const fallback = isTeam
      ? '/wp-content/themes/sef-leagues/images/generic-team.png'
      : '/wp-content/themes/sef-leagues/images/player_no_image.png';
    const imagePrio = isTeam ? data?.logoImage : data?.playerImage;

    const image =
      imagePrio && imagePrio !== ''
        ? getProxyUrl(imagePrio, 529, 500)
        : fallback;

    return image;
  };

  return (
    <div className="player-bust">
      <div className="player-bust__images--front-page">
        <img
          alt="player"
          className={
            !isTeam
              ? 'player-bust__player-image--front-page'
              : 'absolute top-0 object-contain'
          }
          src={getImage()}
        />
        {!isTeam && (
          <img
            alt="team"
            className="player-bust__team-image"
            src={
              getProxyUrl(data.teamLogo) ||
              '/wp-content/themes/sef-leagues/images/generic-team.png'
            }
          />
        )}
      </div>
      {!isTeam && (
        <a
          style={{ pointerEvents: playerUrl && !isTeam ? 'auto' : 'none' }}
          href={playerUrl || ''}
          className="player-bust__info text-decoration-none"
        >
          <p className="player-bust__number m-0">{data.topListNumber}</p>
          <div className="player-bust__name m-0">
            <p className="heading-h6 text-transform-none m-0">
              {getPlayerName()?.firstRow}
            </p>
            <p className="heading-h5 text-transform-none m-0">
              {getPlayerName()?.secondRow}
            </p>
          </div>
        </a>
      )}
    </div>
  );
}

LeadersHero.propTypes = {
  data: PropTypes.shape({}).isRequired,
  type: PropTypes.string.isRequired,
};

export default LeadersHero;
